/* eslint-disable no-console */
import React, { useState, useEffect, useRef, useContext } from 'react';
import $ from 'jquery';
import { get, isEmpty, map, uniqBy, filter, find } from 'lodash';
import { Box, Grid, Radio, Stack, styled, Switch, Typography } from '@mui/material';
import CLRoTable from './clro-table';
import { isObjectEmpty } from '../../shared/helper';
import {
  defaultModalOptions, defaultCLRoTableData, defaultUnitValues, defaultElementParameters,
  unitsForPressure_atm
} from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { ro_options } from './ro-optins-constvar';
import { getBorderColor } from '../../shared/utils';
import { ro_elem_shared_access, clro_elm_shared_access_stageZero } from './ro-element-access';
import { roUserbased_elemodel } from './ro-userbased-em';
import {
  convertUnitValues_pressure,
  convertUnitValues_flow,
  convertUnitValues_flux,
  convertUnitValues_volume
} from '../../shared/conversion-helper/unitConversion';
import { CLRoContext } from './argo-input/contextcall';
import './ro.scss';
import ClroRadioButtonsGroup from './clro-radio-button';
import { addInABFobj, updateOneKeyInABFObj, getAbValFactCheckedDict, setCaptuBoolean } from '../userData';

const checkPressureUnit = {};
const previousUnit = {}; // eslint-disable-next-line
let myUniqElementdict;
let currentFlag = true; // by sudarsana added for PrssureDrop field in CLRO Form
let currentVal = 0; // by sudarsana added for PrssureDrop field in CLRO Form
let unit_set_dict = {}; // by sudarsana added for PrssureDrop field in CLRO Form
const resRange = { min: 0, max: 0 }; // by sudarsana added for PrssureDrop field in CLRO Form
const CLRoFeedAnalysis = (props) => {
  const { dbTransactionDetails, updateElementParameters,
    roDetails, elementParameters, handleCloseRo, disabledStripperAndExplorerTab, setIsElementModelAccess,
    getnType, setElementParameters, setIsShowErrorMessage, isShowErrorMessage, translateObject, setSchematicViewFlag, edges, getIdRoForm } = props;
  const handleSaveCLRocontextTableData = useContext(CLRoContext);
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [units, setUnits] = useState(defaultUnitValues);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [recyclePermeate, setRecyclePermeate] = useState(''); // naah

  const [totalHoldupVol, setTotalHoldupVol] = useState('');
  const [permeateFlux, setPermeateFlux] = useState('');
  const [recovery, setRecovery] = useState(75.0);
  const [clroS1s2s3, setClroS1s2s3] = useState({ s1: 0, s2: 0, s3: 0 });
  const [captuROS1s2s3, setCaptuROS1s2s3] = useState({ s0: 0, s1: 0, s2: 0, s3: 0, s4: 0 });
  // by sudarsana added for PrssureDrop field in CLRO Form
  const [pressureDrop, setpressureDrop] = useState(0.51);
  // CAPTU RO declaration START https://vwts.atlassian.net/browse/GB-2874 by chandrashekhar
  const [flowDropPurge, setFlowDropPurge] = useState(0.002222222);
  const [recoverybrine, setRecoverybrine] = useState(20);
  const [elementDiameter, setElementDiameter] = useState(8);
  // CAPTU RO declaration END https://vwts.atlassian.net/browse/GB-2874 by chandrashekhar
  const [recoveryPerCircuit, setRecoveryPerCircuit] = useState(0);
  const [conc_recirc_flow, setConc_recirc_flow] = useState(0.00111111); //  default value in m3/s for Conc. Recirculation rate (per PV)
  const [roTypes, setRoTypes] = useState(false);
  const [roInputDetails, setRoInputDetails] = useState({ splitPermeate: 0.00, permeateBypass: 0.00 });
  const [elements] = useState([]);
  const [, setEnableRecycle] = useState(true);
  const options = JSON.parse(localStorage.getItem('options'));
  const abFactor = get(options, 'abFactor', '0');
  const systemUnits = JSON.parse(localStorage.getItem('system-units'));
  const pressure = get(systemUnits, 'pressure', 'atm');
  // const
  const [rowData, setRowData] = useState(defaultCLRoTableData()); // Set rowData to Array of Objects, one Object per Row
  const [clroRadioSelectedValue, setClroRadioSelectedValue] = useState('0');
  const [captu_ro, setCaptu_ro] = React.useState(false);
  const [is_primary, setIs_primary] = React.useState(true);

  const handleChangeRadio = (event) => {
    setClroRadioSelectedValue(event.target.value);
    localStorage.setItem('options', JSON.stringify({ abFactor: event.target.value }));
  };

  handleSaveCLRocontextTableData.rowData = rowData;
  const colDefArr = [
    { tag: 'stage', hdata: translateObject('Stage'), disabled: true, datatype: 'number', st: 50 },
    { tag: 'pressureVessels', hdata: translateObject('Pressure Vessels'), disabled: true, datatype: 'number', st: 70 },
    { tag: 'elementsperVessel', hdata: translateObject('Elements per Vessel'), disabled: true, datatype: 'number', st: 75 },
    { tag: 'spacersperVessel', hdata: translateObject('Spacers per Vessel'), disabled: true, datatype: 'number', st: 75 },
    { tag: 'application', hdata: translateObject('Application'), disabled: true, datatype: 'select' },
    { tag: 'elementGroup', hdata: translateObject('Element Group'), disabled: true, datatype: 'select' },
    { tag: 'elementModel', hdata: translateObject('Element Model'), disabled: true, datatype: 'select' },
    {
      tag: 'fluxAnnual', hdata: `${abFactor === '0' ?
        translateObject('Flux Annual % Change') : translateObject('A-Value Factor')}`,
      disabled: true, datatype: 'number', st: 75
    },
    {
      tag: 'saltPassageAnnual', hdata: `${abFactor === '0' ?
        translateObject('Salt Passage Annual % Change') : translateObject('B-Value Factor')}`,
      disabled: true, datatype: 'number', st: 75
    },
    // remove disable property by chandrashekhar because Permeate Pressure no need to disable in clro(DSSRO) form
    // { tag: 'permeatePressure', hdata: `${translateObject('Permeate Pressure')} (${pressure})`, disabled: true, datatype: 'number', st: 105 },
    { tag: 'permeatePressure', hdata: `${translateObject('Permeate Pressure')} (${pressure})`, datatype: 'number', st: 105 },
    { tag: 'elementInfo', hdata: translateObject('Element Info'), disabled: null, datatype: 'button', className: 'clro-btn' }
  ];

  let curRoUnitopName;

  if (abFactor === '0') {
    colDefArr.splice(7, 0, {
      tag: 'elementAge',
      hdata: translateObject('Element Age (yr)'),
      datatype: 'number',
      disabled: true
    });
  }
  useEffect(() => {
    // by sudarsana added this if condtion for PressureDrop value conversion in CLRO form
    unit_set_dict = { ...defaultUnitValues };
    if (localStorage.getItem('system-units')) {
      const unitSet_dict = JSON.parse(localStorage.getItem('system-units'));
      unit_set_dict = { ...unitSet_dict };
    }
  }, []);
  const [option, setOption] = useState(ro_options);

  const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
  let arrData = map(elementsDict, (row) => row);
  // To remove n-element NF element in clro
  // filter array data to remove nType NA for clro
  // filter out element if SelectionA or SelectionB contain 'NF' as a subString (case sensitive)
  const updatedArrData = arrData.filter((item) => {
    return item;
  });

  arrData = [...updatedArrData];
  // sort the element in asc. order based on EID value
  arrData.sort((a, b) => a.EID - b.EID);

  const setApplnDropdn = (row) => {
    const dummyOption = option;
    const uniqApplications = uniqBy(arrData, 'SelectionA');
    const uniqApplnDDvalues = ['', ...map(uniqApplications, 'SelectionA')];
    dummyOption[row].application = uniqApplnDDvalues;
    setOption(dummyOption);
  };

  const setElemGrpDropdn = (row, value) => {
    const elementGroup = filter(arrData, { SelectionA: value });
    const uniqElementGroup = uniqBy(elementGroup, 'SelectionB');
    const uniqElemGrpDDvalues = ['', ...map(uniqElementGroup, 'SelectionB')];
    option[row].elementGroup = uniqElemGrpDDvalues;
  };

  const setElemModelDropdn = (row, applnValue, eleGrpvalue) => {
    const elementModel = filter(arrData, { SelectionA: applnValue, SelectionB: eleGrpvalue });
    const userbased_elementModel = roUserbased_elemodel(elementModel, dbTransactionDetails.users_dict);
    option[row].elementModel = userbased_elementModel;
  };
  const updateMinandMaxValue = () => {
    const resRange = { min: 0, max: 68.05 };
    const previous_pressure_unit = 'atm';
    resRange.min = Number(convertUnitValues_pressure(resRange.min, previous_pressure_unit, pressure));
    resRange.max = Number(convertUnitValues_pressure(resRange.max, previous_pressure_unit, pressure));
    return resRange;
  };

  const handleAfterBlur = (evt) => {
    const { id, value } = evt.target;
    const flag = id.indexOf('_', 9);
    const row = Number(id.substring(9, flag)) - 1;    // row Number
    const col = Number(id.substring(flag + 1)) - 1; // col number
    const filteredData = rowData;                 // grid data
    const curRow = filteredData[row];             // curr row data

    const curColname = colDefArr[col].tag;

    if (curColname === 'elementAge' && value !== '' && value !== 0) {
      if (value < 0 || value > 10) {
        evt.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Element Age (yr) must be in the range 0-10'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.elementAge = 10;
      } else {
        curRow.elementAge = Number(value);
      }
    }

    // if (curColname === 'permeatePressure' && value !== '' && value !== 0) {
    //   if (value < 0 || value > 68.05) {
    //     evt.preventDefault();
    //     setModalOption({
    //       ...defaultModalOptions,
    //       visible: true,
    //       title: 'Warning',
    //       message: translateObject('Permeate Pressure (atm) must be in the range 0-68.05'),
    //       yesOrNo: false,
    //       onNo: () => setModalOption(defaultModalOptions)
    //     });
    //     curRow.permeatePressure = 68.05;
    //   } else {
    //     curRow.permeatePressure = Number(value);
    //   }
    // }
    if (curColname === 'permeatePressure' && value !== '' && value !== 0) {
      const resRange = updateMinandMaxValue(value);
      if (value < resRange.min || value > resRange.max) {
        evt.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: `Permeate Pressure must be in the range ${resRange.min}-${(resRange.max).toFixed(2)} (${pressure})`,
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.permeatePressure = resRange.max;
      } else {
        curRow.permeatePressure = Number(value);
      }
    }

    if (curRow.stage === filteredData[row].stage) {
      filteredData[row].pressureVessels = Number(curRow.pressureVessels);
      filteredData[row].elementsperVessel = Number(curRow.elementsperVessel);
      filteredData[row].spacersperVessel = Number(curRow.spacersperVessel);
      filteredData[row].application = curRow.application;
      filteredData[row].elementGroup = curRow.elementGroup;
      filteredData[row].elementModel = curRow.elementModel;
      filteredData[row].elementAge = Number(curRow.elementAge).toFixed(2);
      filteredData[row].fluxAnnual = Number(curRow.fluxAnnual).toFixed(2);
      filteredData[row].saltPassageAnnual = Number(curRow.saltPassageAnnual).toFixed(2);
      filteredData[row].permeatePressure = Number(curRow.permeatePressure).toFixed(2);
    }
    setRowData(filteredData);
    const loc = JSON.parse(localStorage.getItem('clro-stage-data')) || {};
    const locData = { ...loc, [`stage${curRow.stage}`]: curRow };
    localStorage.setItem('clro-stage-data', JSON.stringify(locData));

  }; //  end of handleAfterBlur()
  function clearForm(flag = true) {
    const clearFormArrData = [];
    for (let i = 1; i < 2; i += 1) {
      clearFormArrData.push({
        stage: i,
        pressureVessels: 0,
        elementsperVessel: 0,
        spacersperVessel: 0,
        application: '',
        elementGroup: '',
        elementModel: '',
        elementAge: 0.00,
        fluxAnnual: 0.00,
        saltPassageAnnual: 0.00,
        permeatePressure: 0.00,
      });
    }
    setRowData([...clearFormArrData]);
    $('.clro-table_container input').attr('disabled', true);
    $('.clro-table_container select').attr('disabled', true);
    $('.clro-table_container .row_1 input').attr('disabled', null);
    $('.clro-table_container .row_1 select').attr('disabled', null);
    $('.clro-table_container #input_num1_1').attr('disabled', true);
    $('.clro-table_container #input_num1_12').attr('disabled', true);
    // commen by chandrashekhar because Permeate Pressure no need to disable in clro(DSSRO) form
    // $('.clro-table_container #input_num1_11').attr('disabled', abFactor === '0' ? true : false);
    $('.clro-table_container select').css({ 'min-width': '9vw', 'max-width': '9vw' });
    if (flag) {
      const default_flow_units = 'm3/s';
      const pressurePurge = parseFloat(convertUnitValues_pressure(0.510, 'atm', unit_set_dict.pressure));
      setpressureDrop(pressurePurge);
      // captu RO START
      const flowPurge = parseFloat(convertUnitValues_flow(0.002222222, default_flow_units, unit_set_dict.flow));
      setFlowDropPurge(flowPurge.toFixed(unit_set_dict.flow === default_flow_units ? 5 : 3));
      setRecoverybrine(20);
      // convert the default value m3/s to selected units.
      const recirc_flow = parseFloat(convertUnitValues_flow(0.00111111, default_flow_units, unit_set_dict.flow));
      setConc_recirc_flow(recirc_flow.toFixed(unit_set_dict.flow === default_flow_units ? 5 : 3));
      // captu RO END`
    }
  }
  const elementDiameterDefaultValue = (val) => {
    // default set 8 inch element
    const obj = { min: 0.001111111111, max: 0.003055556, defaultVal: 0.002222222 };
    if (val === 2) {
      obj.min = 0.00011285; obj.max = 0.00019097; obj.defaultVal = 0.000138889;
    } else if (val === 4) {
      obj.min = 0.000451389; obj.max = 0.000763889; obj.defaultVal = 0.000555556;
    } else if (val === 8) {
      obj.min = 0.001111111111; obj.max = 0.003055556; obj.defaultVal = 0.002222222;
    } else if (val === 16) {
      obj.min = 0.00722222; obj.max = 0.01222222; obj.defaultVal = 0.008888889;
    }
    return obj;
  };
  const onValueChange = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const { id, value } = e.target;
    const flag = id.indexOf('_', 9);
    const row = Number(id.substring(9, flag)) - 1;    // row Number
    const col = Number(id.substring(flag + 1)) - 1; // col number
    const filteredData = rowData;                 // grid data
    const curRow = filteredData[row];             // curr row data
    const curColname = colDefArr[col].tag;
    const prevCol = colDefArr[col - 1].tag;

    if (curColname === 'pressureVessels') {
      if (Number(value) < 0 || Number(value) > 999) {
        e.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Pressure Vessels must be in the range 0-999'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.pressureVessels = 0;
      } else if (value === '0') {
        curRow.elementsperVessel = 0;
        curRow.spacersperVessel = 0;
        curRow.application = '';
        curRow.elementGroup = '';
        curRow.elementModel = '';
        curRow.elementAge = 0.00;
        curRow.fluxAnnual = 0.00;
        curRow.saltPassageAnnual = 0.00;
        curRow.permeatePressure = 0.00;
        option[row].application = [];
        option[row].elementGroup = [];
        option[row].elementModel = [];
        if (Number(filteredData[row + 1].pressureVessels) !== 0) {
          $(`.clro-table_container .row_${row + 3} input`).attr('disabled', null);
          $(`.clro-table_container .row_${row + 3} select`).attr('disabled', null);
          $(`.clro-table_container #input_num${row + 3}_1`).attr('disabled', true);
        }
      } if (value === '');
      else {
        curRow.pressureVessels = Number(value);
      }
    }

    if (curColname === 'elementsperVessel') {
      if (value < 0 || value > 8) {
        e.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Elements per Vessel must be in the range 0-8'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.elementsperVessel = 8;
      } else if (Number(value) === 0 || value === '') {
        curRow.application = '';
        curRow.elementGroup = '';
        curRow.elementModel = '';
        curRow.saltPassageAnnual = 0;
        curRow.fluxAnnual = 0;
        option[row].application = [];
        option[row].elementGroup = [];
        option[row].elementModel = [];
        if (Number(filteredData[row + 1].pressureVessels) === 0) {
          $(`.clro-table_container .row_${row + 3} input`).attr('disabled', true);
          $(`.clro-table_container .row_${row + 3} select`).attr('disabled', true);
        }
      } else if ((curRow[prevCol] <= 0 || curRow[prevCol] === '') && col <= 6) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: `${colDefArr[col - 1].hdata} must not be empty`,
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.elementsperVessel = 0;
      } else {
        curRow.elementsperVessel = Number(value);
        if (Number(curRow.elementsperVessel) + Number(curRow.spacersperVessel) > 8) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: translateObject('Sum of Element per Vessel & Spacers per Vessel must be <= 8'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
          curRow.spacersperVessel = 0;
        }
        setApplnDropdn(row);
      }
    }

    if (curColname === 'spacersperVessel') {
      if (value < 0 || value > 8) {
        e.preventDefault();
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Spacer per Vessel must be in the range 0-8'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.spacersperVessel = 8 - curRow.elementsperVessel;
      } else if (Number(value) === 0 || value === '') {
      } else if ((curRow[prevCol] <= 0 || curRow[prevCol] === '') && col <= 6) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: `${colDefArr[col - 1].hdata} must not be empty`,
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        curRow.spacersperVessel = 0;
      } else {
        curRow.spacersperVessel = Number(value);
        if (Number(curRow.elementsperVessel) + Number(curRow.spacersperVessel) > 8) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: translateObject('Sum of Element per Vessel & Spacers per Vessel must be <= 8'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
          curRow.spacersperVessel = 0;
        }
        setApplnDropdn(row);
      }
    }

    if (curColname === 'application' && value !== '') {
      curRow.application = value;
      setElemGrpDropdn(row, value);
      curRow.elementGroup = '';
      curRow.elementModel = '';
      option[row].elementModel = [];

      if (curRow.application === '') {
        curRow.fluxAnnual = Number(0.00);
        curRow.saltPassageAnnual = Number(0.00);
      } else if (Number(abFactor) === 0) {
        // @sudarsana this is display the default values based on condtion by tracesing the paths
        const flow_sheet_dict_raw = localStorage.getItem('flow_sheet_dict');
        const flow_sheet_dict = flow_sheet_dict_raw ? JSON.parse(flow_sheet_dict_raw) : null;

        const getedgeForm = edges.filter(e => e.target === getIdRoForm);
        const getWasteConnectionForm = getedgeForm?.[0]?.sourceHandle ?? null;

        const gethppumpTarget = edges.filter(
          e => e.target === `hppump_${getIdRoForm?.split('_')?.[1]}`
        );
        const getWasteConnectionFormRO_HP = gethppumpTarget?.[0]?.sourceHandle ?? null;

        const hpSource = gethppumpTarget?.[0]?.source; // guarded
        const getWasterROERD = hpSource ? edges.filter(e => e.target === hpSource) : [];
        const getWasteConnectionFormRO_ERD = getWasterROERD?.[0]?.sourceHandle ?? null;
        if ((getWasteConnectionForm === 'd' || getWasteConnectionFormRO_HP === 'd' || getWasteConnectionFormRO_ERD === 'd')) {
          curRow.fluxAnnual = Number(5.00);
          curRow.saltPassageAnnual = Number(7.00);
          localStorage.removeItem('flow_sheet_dict_wastage');
        }
        else if ((flow_sheet_dict && flow_sheet_dict.Type !== '1 Pass' && getIdRoForm !== 'roPump_1')) {
          curRow.fluxAnnual = Number(2.00);
          curRow.saltPassageAnnual = Number(2.00);
        } else if (getIdRoForm !== 'roPump_1' && (getWasteConnectionForm === 'c' || getWasteConnectionFormRO_HP === 'c')) {
          curRow.fluxAnnual = Number(2.00);
          curRow.saltPassageAnnual = Number(2.00);
        }
        else {
          curRow.fluxAnnual = Number(5.00);
          curRow.saltPassageAnnual = Number(7.00);
        }
      } else {
        curRow.fluxAnnual = Number(1.00);
        curRow.saltPassageAnnual = Number(1.00);
      }
    }
    if (curColname === 'elementGroup' && value !== '') {
      curRow.elementGroup = value;
      setElemModelDropdn(row, curRow[prevCol], value);
    }
    if (curColname === 'elementModel' && value !== '') {
      curRow.elementModel = value;
      $(`.clro-table_container .row_${row + 2} input`).attr('disabled', null);
      $(`.clro-table_container .row_${row + 2} select`).attr('disabled', null);
      $(`.clro-table_container #input_num${row + 2}_1`).attr('disabled', true);
      const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
      const arrData = map(elementsDict, (row) => row);
      const currStage = find(arrData, { SelectionA: curRow.application, SelectionB: curRow.elementGroup, strModel: curRow.elementModel });
      // Captu RO conversion START
      setElementDiameter(currStage.ElementDiameter);
      const { defaultVal } = elementDiameterDefaultValue(currStage.ElementDiameter);
      const flowPurge = parseFloat(convertUnitValues_flow(defaultVal, 'm3/s', unit_set_dict.flow));
      setFlowDropPurge(flowPurge.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));
      // Captu RO conversion END
      getnType(currStage.nType);
      setElementParameters(currStage);
    }

    if ((curColname === 'fluxAnnual' || curColname === 'saltPassageAnnual') && value !== '') {
      const curUnopName = roDetails.id;
      updateOneKeyInABFObj(curUnopName, false);
    }

    disabledStripperAndExplorerTab();
    setSchematicViewFlag(false);
  }; // end of onValueChange()

  const convertPressure = (griddata) => {
    const units = JSON.parse(localStorage.getItem('system-units')) || {};
    let previous_pressure_unit = '';
    if (previousUnit[roDetails.id]) {
      previous_pressure_unit = previousUnit[roDetails.id];
    } else {
      previous_pressure_unit = checkPressureUnit[roDetails.id];
    }
    if (checkPressureUnit[roDetails.id] !== previous_pressure_unit && checkPressureUnit[roDetails.id] !== undefined) {
      for (let i = 0; i < 1; i += 1) {
        const iterationCheck = Number(griddata[i].pressureVessels);
        const interStagePressureLoss = parseFloat(griddata[i].interStagePressureLoss);
        const interStageBoostPressure = parseFloat(griddata[i].interStageBoostPressure);
        const permeatePressure = parseFloat(griddata[i].permeatePressure);
        if (iterationCheck > 0) {
          const pressureunit = units.pressure ? units.pressure : 'atm';
          griddata[i].interStagePressureLoss = parseFloat(convertUnitValues_pressure(
            interStagePressureLoss, previous_pressure_unit, pressureunit
          ));
          griddata[i].interStageBoostPressure = parseFloat(convertUnitValues_pressure(
            interStageBoostPressure, previous_pressure_unit, pressureunit
          ));
          griddata[i].permeatePressure = parseFloat(convertUnitValues_pressure(
            permeatePressure, previous_pressure_unit, pressureunit
          ));
        } else {
          break;
        }
      }
    }
    setRowData(griddata);
    previousUnit[roDetails.id] = checkPressureUnit[roDetails.id];
  };

  function fetchFormDatafromLocalStorage(roRecord) {
    if (isObjectEmpty(roRecord)) {
      updateElementParameters(roRecord.elementParameters || {});
      setRecyclePermeate(roRecord.recyclePermeate || false);
      setRoTypes(roRecord.roTypes || false);
      setRecovery(roRecord.recovery || 0.0);
      setRecoveryPerCircuit(roRecord.recoveryPerCircuit || 0.0);
      setRoInputDetails(roRecord.roInputDetails || { splitPermeate: 0.00, permeateBypass: 0.00 });
      // by sudarsana added for PrssureDrop field in CLRO Form
      if (!roRecord.captu_ro && roRecord.pressureDrop) {
        const pressurePurge = parseFloat(convertUnitValues_pressure(roRecord.pressureDrop, 'atm', unit_set_dict.pressure));
        setpressureDrop(pressurePurge);
      }
      if (roRecord.captu_ro && roRecord.captuFlow) {
        const flowPurge = parseFloat(convertUnitValues_flow(roRecord.captuFlow, 'm3/s', unit_set_dict.flow));
        setFlowDropPurge(flowPurge.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));
      } else {
        const { defaultVal } = elementDiameterDefaultValue(elementDiameter);
        const flowPurge = parseFloat(convertUnitValues_flow(defaultVal, 'm3/s', unit_set_dict.flow));
        setFlowDropPurge(flowPurge.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));
      }
      const recirc_flow = parseFloat(convertUnitValues_flow(roRecord.conc_recirc_flow || 0.00111111, 'm3/s', unit_set_dict.flow));
      setConc_recirc_flow(recirc_flow.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));

      if (roRecord.captu_ro && roRecord.brine_purge_recovery >= 0 || roRecord.brine_purge_recovery <= 20) {
        setRecoverybrine(roRecord.brine_purge_recovery);
      } else {
        setRecoverybrine(20);
      }
      if (roRecord.totalHoldupVol) {
        const holdupVolVal = parseFloat(convertUnitValues_volume(roRecord.totalHoldupVol, 'm3', unit_set_dict.volume));
        setTotalHoldupVol(holdupVolVal.toFixed(2));
      }
      if (roRecord.permeateFlux) {
        const permeateFluxVal = parseFloat(convertUnitValues_flux(roRecord.permeateFlux, 'm/s', unit_set_dict.flux));
        setPermeateFlux(permeateFluxVal.toFixed(2));
      }
      setCaptu_ro(roRecord.captu_ro ? roRecord.captu_ro : false);
      setCaptuBoolean(roRecord.captu_ro ? roRecord.captu_ro : false);
      if (roRecord.is_primary === undefined) {
        setIs_primary(true);
      } else {
        setIs_primary(roRecord.is_primary);
      }

      if (!roRecord.captu_ro) {
        setClroS1s2s3((prevState) => ({
          ...prevState,
          s1: roRecord.s1_frac ? roRecord.s1_frac : 0,
          s2: roRecord.s2_frac ? roRecord.s2_frac : 0,
          s3: roRecord.s3_frac ? roRecord.s3_frac : 0,
        }));
      } else {
        setCaptuROS1s2s3((prevState) => ({
          ...prevState,
          s0: roRecord.s0_frac ? roRecord.s0_frac : 0,
          s1: roRecord.s1_frac ? roRecord.s1_frac : 0,
          s2: roRecord.s2_frac ? roRecord.s2_frac : 0,
          s3: roRecord.s3_frac ? roRecord.s3_frac : 0,
          s4: roRecord.s4_frac ? roRecord.s4_frac : 0,
        }));
      }
      clearForm(false);
      const griddata = roRecord['grid-data'];
      convertPressure(roRecord['grid-data']);
      let row = 0;
      while (row < 1) {
        if (Number(griddata[row].pressureVessels) !== 0) {
          $(`.clro-table_container .row_${row + 2} input`).attr('disabled', null);
          $(`.clro-table_container .row_${row + 2} select`).attr('disabled', null);
          $(`.clro-table_container #input_num${row + 2}_1`).attr('disabled', true);
          setApplnDropdn(row);
          setElemGrpDropdn(row, griddata[row].application);
          setElemModelDropdn(row, griddata[row].application, griddata[row].elementGroup);

          // checking the abFactor
          if (abFactor === '0') { // if 0 -> then check both value is 1 n 1 that means user din't update the value, so update it to default
            // convert fluxAnnual & saltPassageAnnual in to number to compare
            if (getAbValFactCheckedDict()[curRoUnitopName]) {
              griddata[row].fluxAnnual = '5.00';
              griddata[row].saltPassageAnnual = '7.00';
            }
          } else {  // eslint-disable-next-line
            if (getAbValFactCheckedDict()[curRoUnitopName]) {
              griddata[row].fluxAnnual = '1.00';
              griddata[row].saltPassageAnnual = '1.00';
            }
          }
        } else {
          break;
        }
        row += 1;
      }
    } else {
      updateElementParameters({});
      setRecyclePermeate(false);
      setRoTypes(false);
      setRecovery(75.0);
      setTotalHoldupVol('');
      setPermeateFlux('');
      // by sudarsana added for PrssureDrop field in CLRO Form
      const pressurePurge = parseFloat(convertUnitValues_pressure(0.510, 'atm', unit_set_dict.pressure));
      setpressureDrop(pressurePurge);
      const flowPurge = parseFloat(convertUnitValues_flow(0.002222222, 'm3/s', unit_set_dict.flow));
      setFlowDropPurge(flowPurge.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));
      const recirc_flow = parseFloat(convertUnitValues_flow(0.00111111, 'm3/s', unit_set_dict.flow));
      setConc_recirc_flow(recirc_flow.toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3));
      setRecoveryPerCircuit(0);
      setRecoverybrine(20);
      setRoInputDetails({ splitPermeate: 0.00, permeateBypass: 0.00 });
      clearForm();
    }
  }

  const getElemPropInfoOnClickEM = () => {
    $('#input_num1_7').focus(() => {
      const currStage = find(arrData, {
        SelectionA: $('#input_num1_5').val(),
        SelectionB: $('#input_num1_6').val(), strModel: $('#input_num1_7').val()
      });
      getnType(currStage.nType);
      setElementParameters(currStage);
    });
  };

  useEffect(() => {
    let abFactRow;
    if (abFactor === '1') {
      $('#input_num1_11').val('');
      $('.clro-btn').val('');
      $('#input_num1_11').removeAttr('value');
      $('.clro-btn').removeAttr('value');

      abFactRow = rowData.map((item) => {
        if (item.application) {
          item.fluxAnnual = '1.00';
          item.saltPassageAnnual = '1.00';
        }
        return item;
      });
    }

    if (abFactor === '0') {
      abFactRow = rowData.map((item) => {
        if (item.application) {
          item.fluxAnnual = '5.00';
          item.saltPassageAnnual = '7.00';
        }
        return item;
      });
    }

    setRowData(abFactRow);
    setClroRadioSelectedValue(abFactor);
  }, [abFactor]);

  useEffect(() => {
    setClroRadioSelectedValue(abFactor);

    // getElement Parameter/Info OnClick of Element Model for the footer section
    getElemPropInfoOnClickEM();

    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('system-units')));
      checkPressureUnit[roDetails.id] = JSON.parse(localStorage.getItem('system-units')).pressure ?
        JSON.parse(localStorage.getItem('system-units')).pressure : 'atm';
    } else {
      checkPressureUnit[roDetails.id] = units.pressure ? units.pressure : 'atm';
    }
    if (isObjectEmpty(roDetails)) {
      const { id } = roDetails;

      curRoUnitopName = roDetails.id;
      // update value to false only when value is not true
      if (!(getAbValFactCheckedDict()[curRoUnitopName]))
        addInABFobj(roDetails.id, false);

      const localData = get(JSON.parse(localStorage.getItem('clro-dict')), 'ro', {});
      clro_elm_shared_access_stageZero(localData);
      const localData_updated = get(JSON.parse(localStorage.getItem('clro-dict-temp')), 'ro', {});
      if (isObjectEmpty(localData_updated)) {
        const pressurePurge = parseFloat(convertUnitValues_pressure(0.510, 'atm', unit_set_dict.pressure));
        setpressureDrop(pressurePurge);
        const roRecord = localData_updated[id];
        // added by chandrashekhra to set the old file ElementDiameter GB-2874 START
        if (roRecord && roRecord.elementParameters && roRecord.elementParameters.ElementDiameter) {
          setElementDiameter(roRecord.elementParameters.ElementDiameter);
        } else {
          let modelVal = '';
          if (roRecord && roRecord['grid-data']) {
            modelVal = roRecord['grid-data'][0].elementModel;
          }
          const finalVal = Object.values(elementsDict).filter((ele) => {
            return ele.strModel === modelVal;
          });
          if (finalVal.length) {
            setElementDiameter(finalVal[0].ElementDiameter);
          }
        }
        // added by chandrashekhra to set the old file ElementDiameter GB-2874 END
        fetchFormDatafromLocalStorage(roRecord);
        const obj = {};
        if (roRecord) {
          for (let i = 0; i < 1; i += 1) {
            obj[`stage${roRecord['grid-data'][i].stage}`] = roRecord['grid-data'][i];
          }
          localStorage.setItem('clro-stage-data', JSON.stringify(obj));
          // Reset Element Paramater dict. to default one
          setElementParameters(defaultElementParameters);
        }
      } else {
        clearForm();
      }
    }
  }, [roDetails]);

  // by sudarsana added for PrssureDrop field in CLRO Form
  const getCurrentValue = (e) => {
    if (currentFlag) {
      currentFlag = false;
      currentVal = (e.target.value) ? Number(e.target.value) : 0;
    }
  };
  const showErrorMessage = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      yesOrNo: false,
      type: 'error',
      title: 'Error',
      message: translateObject('Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type'),
      onYes: () => handleCloseRo(),
      onNo: () => setModalOption(defaultModalOptions)
    });
  };

  const enableRecyclePermeate = async () => {
    const record = rowData;
    const stagedData = record.filter((obj) => obj.pressureVessels !== 0);
    if (stagedData.length > 1) {
      setEnableRecycle(false);
    } else {
      setEnableRecycle(true);
      setRecyclePermeate(false);
    }
  };

  const validateFields = (stagedData) => {
    return stagedData.some((obj) => {
      const { application, elementGroup, elementModel, elementsperVessel } = obj;
      return (application === '' || elementGroup === '' || elementModel === '' || elementsperVessel === 0);
    });
  };
  const handlePressureDrop = (event) => {
    const { value } = event.target;
    if (captu_ro) {
      const previous_pressure_unit = 'm3/s';
      const minMaxVal = elementDiameterDefaultValue(elementDiameter);
      resRange.min = parseFloat(convertUnitValues_flow(minMaxVal.min, previous_pressure_unit, unit_set_dict.flow));
      resRange.max = parseFloat(convertUnitValues_flow(minMaxVal.max, previous_pressure_unit, unit_set_dict.flow));
    } else {
      const previous_pressure_unit = 'atm';
      resRange.min = 0.34; resRange.max = 0.68;
      resRange.min = parseFloat(convertUnitValues_pressure(resRange.min, previous_pressure_unit, unit_set_dict.pressure));
      resRange.max = parseFloat(convertUnitValues_pressure(resRange.max, previous_pressure_unit, unit_set_dict.pressure));
    }
    currentFlag = true;
    if (!(value >= resRange.min && value <= resRange.max)) {
      let message;
      if (captu_ro) {
        message = `Feed flow (per PV) during brine purge in Captu RO mode should be between 
        ${(resRange.min).toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3)} - ${(resRange.max).toFixed(unit_set_dict.flow === 'm3/s' ? 5 : 3)} 
        ${unit_set_dict.flow}`;
      } else {
        message = `DP value should be in the range of ${resRange.min} - ${resRange.max} ${unit_set_dict.pressure}`;
      }
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      if (captu_ro) {
        setFlowDropPurge(currentVal);
      } else {
        setpressureDrop(currentVal);
      }
      return false;
    }
    if (captu_ro) {
      setFlowDropPurge(event.target.value);
    } else {
      setpressureDrop(event.target.value);
    }
    disabledStripperAndExplorerTab();
    setSchematicViewFlag(false);
    return true;
  };
  handleSaveCLRocontextTableData.handleSaveCLRoTableData = async (bg_rowdata, isModelClose) => {
    if (recoveryPerCircuit !== '' && (recoveryPerCircuit > 100 || recoveryPerCircuit < 0)) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Recovery Per Circuit must be in the range 0-100%'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      return false;
    }
    // added by chandrashekhar when user click on ok in CLRO form previousaly validation not checked but now check condition GB-3325
    currentVal = captu_ro ? flowDropPurge : pressureDrop;
    const pressureDropFlag = handlePressureDrop({ target: { value: currentVal } });
    if (!pressureDropFlag) return false;
    // added by chandrashekhar when user click on ok in CLRO form previousaly validation not checked  but now check condition GB-3325
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    const record = bg_rowdata;
    const { id } = roDetails;
    const options = JSON.parse(localStorage.getItem('options'));
    const abFactor = get(options, 'abFactor', '0');
    const stagedData = record.filter((obj) => Number(obj.pressureVessels) !== 0);
    const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
    const elementsDict_numElements = {};
    const module_param_dict_1 = {};
    // Added by Akhil to iterate element dict based on highest element id not based on length
    for (let i = 1; i <= Math.max(...Object.keys(elementsDict)); i += 1) {
      if (elementsDict[i.toFixed(1)]) {
        elementsDict_numElements[elementsDict[i.toFixed(1)].strModel] = i.toFixed(1);
      }
    }
    if (isEmpty(stagedData) || validateFields(stagedData)) {
      showErrorMessage();
    } else {
      let flag = false;
      if (captu_ro) {
        const total = Object.values(captuROS1s2s3).reduce((sum, val) => sum + Number(val), 0);
        if (total !== 0 && (total > 1 || total < 0.9999)) {
          flag = true;
        }
      } else {
        const total = Number(clroS1s2s3.s1) + Number(clroS1s2s3.s2) + Number(clroS1s2s3.s3);
        if (total !== 0 && (total > 1 || total < 0.9999)) {
          flag = true;
        }
      }
      if (flag) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Error',
          message: translateObject('Sum of split fraction(s) should be 1.0'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions),
          type: 'error'
        });
        return false;
      }
      const stageObj = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = {
          num_vessels: Number(obj.pressureVessels),
        };
        return stageObject;
      }, {});
      const stageObj_1 = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = {
          num_elements: Number(obj.elementsperVessel),
          num_spacers: Number(obj.spacersperVessel),
        };
        return stageObject;
      }, {});
      const stageObj_iter = stagedData.reduce((stageObject, obj, stIndex) => {
        stageObject[stIndex] = Number(obj.elementsperVessel); // * Number(obj.pressureVessels);
        return stageObject;
      }, {});
      const stageObj_2 = stagedData.reduce((mpDict, obj, mpIndex) => {
        mpDict[mpIndex] = {
          element_id: Number(elementsDict_numElements[obj.elementModel]), // '0',
          age: parseFloat(obj.elementAge),
          boost: 0.0,
          boost_eff: 0.0,
          inter_stage_dp: 0.0,
          back_press: parseFloat(obj.permeatePressure) * unitsForPressure_atm[units.pressure ? units.pressure : 'atm'],
          a_value: parseFloat(obj.fluxAnnual),
          b_value: parseFloat(obj.saltPassageAnnual),
        };
        return mpDict;
      }, {});

      let count = 0;
      let val = 0;
      for (let i = 0; i < Object.keys(stageObj_iter).length; i += 1) {
        if (i > 0) {
          val = count;
          for (let j = val; j < stageObj_iter[i] + val; j += 1) {
            module_param_dict_1[j] = stageObj_2[i];
            count += 1;
          }
        } else {
          for (let j = 0; j < stageObj_iter[i]; j += 1) {
            module_param_dict_1[j] = stageObj_2[i];
            count += 1;
          }
        }
      }

      const payload = {
        split_flow: parseFloat(convertUnitValues_flow(roInputDetails.splitPermeate, units.flow, 'm3/s')),
        recovery: parseFloat(recovery),
        totalHoldupVol: parseFloat(convertUnitValues_volume(totalHoldupVol, unit_set_dict.volume, 'm3')),
        permeateFlux: parseFloat(convertUnitValues_flux(permeateFlux, unit_set_dict.flux, 'm/s')),
        is_recycle_permeate: recyclePermeate,
        num_stages: stagedData.length,
        is_dapc: abFactor === '0',
        feed_press: 0.0,
        delta_temp: 0.0,
        stage_param_dict: stageObj,
        pv_param_dict: stageObj_1, // pv_param_dict_1, // stageObj_1,
        module_param_dict: module_param_dict_1,
        argo_dict: JSON.parse(localStorage.getItem('clro_payload'))?.ro[id]?.argo_dict || null,
        ...(captu_ro && { s0_frac: Number(captuROS1s2s3.s0) }),
        s0_frac: captu_ro ? Number(captuROS1s2s3.s0) : 0,
        s1_frac: captu_ro ? Number(captuROS1s2s3.s1) : Number(clroS1s2s3.s1),
        s2_frac: captu_ro ? Number(captuROS1s2s3.s2) : Number(clroS1s2s3.s2),
        s3_frac: captu_ro ? Number(captuROS1s2s3.s3) : Number(clroS1s2s3.s3),
        ...(captu_ro && { s4_frac: Number(captuROS1s2s3.s4) }),
        // s4_frac: captu_ro ? Number(captuROS1s2s3.s4) : 0,
        captu_ro,
        is_primary
      };
      if (captu_ro) {
        payload.captu_flow = parseFloat(convertUnitValues_flow(flowDropPurge, unit_set_dict.flow, 'm3/s'));
        payload.brine_purge_recovery = Number(recoverybrine);
        payload.conc_recirc_flow = parseFloat(convertUnitValues_flow(parseFloat(conc_recirc_flow), unit_set_dict.flow, 'm3/s'));
      } else {
        payload.dp_brinepurge = parseFloat(convertUnitValues_pressure(pressureDrop, unit_set_dict.pressure, 'atm'));
        payload.recoveryPerCircuit = parseFloat(recoveryPerCircuit);
      }
      saveFormDataInLocalStorage({ record: payload, type: 'ro', id, item: 'clro_payload' });
      const data = {
        'grid-data': rowData,
        elementParameters,
        recyclePermeate,
        roTypes,
        roInputDetails,
        recovery,
        totalHoldupVol: parseFloat(convertUnitValues_volume(totalHoldupVol, unit_set_dict.volume, 'm3')),
        permeateFlux: parseFloat(convertUnitValues_flux(permeateFlux, unit_set_dict.flux, 'm/s')),
        ...(captu_ro && { s0_frac: Number(captuROS1s2s3.s0) }),
        // s0_frac: captu_ro ? Number(captuROS1s2s3.s0) : 0,
        s1_frac: captu_ro ? Number(captuROS1s2s3.s1) : Number(clroS1s2s3.s1),
        s2_frac: captu_ro ? Number(captuROS1s2s3.s2) : Number(clroS1s2s3.s2),
        s3_frac: captu_ro ? Number(captuROS1s2s3.s3) : Number(clroS1s2s3.s3),
        ...(captu_ro && { s4_frac: Number(captuROS1s2s3.s4) }),
        // s4_frac: captu_ro ? Number(captuROS1s2s3.s4) : 0,
        captu_ro,
        is_primary
      };
      if (captu_ro) {
        data.captuFlow = parseFloat(convertUnitValues_flow(flowDropPurge, unit_set_dict.flow, 'm3/s'));
        data.brine_purge_recovery = Number(recoverybrine);
        data.conc_recirc_flow = parseFloat(convertUnitValues_flow(conc_recirc_flow, unit_set_dict.flow, 'm3/s'));
      } else {
        data.pressureDrop = parseFloat(convertUnitValues_pressure(pressureDrop, unit_set_dict.pressure, 'atm'));
        data.recoveryPerCircuit = parseFloat(recoveryPerCircuit);
      }
      saveFormDataInLocalStorage({ record: data, type: 'ro', id, item: 'clro-dict' });

      if (Number(data.recovery) > 0)
        getBorderColor(id);
      // TO DO : Check for shared file's element access when user change them
      const current_clro_stage = JSON.parse(localStorage.getItem('clro-dict'));
      const isCLRoFileChanged = ro_elem_shared_access(current_clro_stage.ro);
      setIsElementModelAccess(!isCLRoFileChanged);
      if (isModelClose) {
        handleCloseRo();
      } else {
        localStorage.setItem('roapply', 1);
      }
    }
  };

  handleSaveCLRocontextTableData.checkUpdate = () => { };

  const handleTotalHoldupVol = (event) => {
    const { name, value } = event.target;
    if (value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: `${name} must be positive number.`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else
      setTotalHoldupVol(event.target.value);
  };

  const updateS1S2S3Value = (value, str) => {
    if (!captu_ro) {
      setClroS1s2s3((prevState) => ({
        ...prevState,
        [str]: value,
      }));
    } else {
      setCaptuROS1s2s3((prevState) => ({
        ...prevState,
        [str]: value,
      }));
    }
  };

  const handlePermeateFlux = (event) => {
    const { name, value } = event.target;
    if (value > 1000 || value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: `${name} must be in the range 0-1000`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else
      setPermeateFlux(event.target.value);
  };
  const handleRecoverybrine = (event) => {
    currentFlag = true;
    const { value } = event.target;
    if (value < 0 || value > 20) {
      setRecoverybrine(currentVal);
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: 'Recovery during brine purge should be between 0 - 20',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      disabledStripperAndExplorerTab();
      setSchematicViewFlag(false);
    }
  };
  const handlerecoveryPerCircuit = (e) => {
    if (captu_ro) {
      // range set here if exist Conc Recirc flow
      setConc_recirc_flow(e.target.value);
      disabledStripperAndExplorerTab();
    } else {
      setIsShowErrorMessage(true);
      localStorage.setItem('globalExitBtn', 'true');
      const { value } = e.target;
      if (value > 100 || value < 0) {
        // if (!captu_ro && (value > 100 || value < 0)) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Recovery Per Circuit must be in the range 0-100%'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
        setRecoveryPerCircuit(0);
      } else {
        setRecoveryPerCircuit(e.target.value);
        disabledStripperAndExplorerTab();
        setSchematicViewFlag(false);
      }
    }
  };

  const handleChangeRecovery = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    const { value } = e.target;
    if (value > 100 || value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Recovery must be in the range 0-100%'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      setRecovery(0);
    } else {
      setRecovery(e.target.value);
      disabledStripperAndExplorerTab();
      setSchematicViewFlag(false);
    }
  };

  const handleClick = (e) => {
    const ID = e.target.id;
    const flag = ID.indexOf('_', 9);
    const row = Number(ID.substring(9, flag)) - 1;
    const data = rowData[row];
    // Spec file
    if (e.target.type === 'button') {
      if (data.elementModel !== '') { // to handle out of current stage
        const elementsDict = get(dbTransactionDetails, 'elements_dict', {});
        const arrData = map(elementsDict, (row) => row);
        const currStage = find(arrData, { SelectionA: data.application, SelectionB: data.elementGroup, strModel: data.elementModel });
        if (currStage.flowsheet_link) {
          window.open(`${currStage.flowsheet_link}`, '_blank', 'noreferrer');
        }
        else {
          setModalOption({ // show warning
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: translateObject('Spec File is not available for this Element.'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
        }
      }
    }
  };
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#0679CC' : '#0679CC',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 500,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#0679CC' : '#0679CC',
      boxSizing: 'border-box',
    },
  }));
  const handleChange = (event, str) => {
    if (str === 'captu') {
      setCaptu_ro(event.target.checked);
      setCaptuBoolean(event.target.checked);
      disabledStripperAndExplorerTab();
      setSchematicViewFlag(false);
    } else if (str === 'primary') {
      setIs_primary(!event.target.checked);
    }
  };
  return (
    <Box sx={{ width: '100%' }}>
      <div className="content-tab-panel clro-feed">
        <Notification
          options={modalOption}
          handleClose={() => setModalOption(defaultModalOptions)}
        />
        <div className="ro-analysis">
          <Grid container spacing={1}>
            <Stack className='no_drag' direction="row" spacing={1} alignItems="center" style={{ marginTop: '2%' }}>
              <Typography style={{
                'fontWeight': captu_ro ? 400 : 600, color: captu_ro ? '#1C1C1F' : '#002D62'
              }}>{translateObject('CLRO')}</Typography>
              <AntSwitch
                inputProps={{ 'aria-label': 'ant design' }}
                checked={captu_ro}
                onChange={(e) => handleChange(e, 'captu')}
              />
              <Typography style={{
                'fontWeight': !captu_ro ? 400 : 600, color: !captu_ro ? '#1C1C1F' : '#002D62'
              }}>{translateObject('Captu RO')}</Typography>
            </Stack>
            <Stack className='no_drag' direction="row" spacing={1} alignItems="center" style={{ marginTop: '2%', marginLeft: '9.8%' }}>
              <Typography style={{
                'fontWeight': !is_primary ? 400 : 600, color: !is_primary ? '#1C1C1F' : '#002D62'
              }}>{translateObject('Primary RO')}</Typography>
              <AntSwitch
                inputProps={{ 'aria-label': 'ant design' }}
                checked={!is_primary}
                onChange={(e) => handleChange(e, 'primary')}
              />
              <Typography style={{
                'fontWeight': is_primary ? 400 : 600, color: is_primary ? '#1C1C1F' : '#002D62'
              }}>{translateObject('Secondary RO')}</Typography>
            </Stack>
            <Grid item xs={12}>
              <ClroRadioButtonsGroup
                totalHoldupVol={totalHoldupVol}
                handleTotalHoldupVol={handleTotalHoldupVol}
                permeateFlux={permeateFlux}
                handlePermeateFlux={handlePermeateFlux}
                recovery={recovery}
                clroS1s2s3={clroS1s2s3}
                captuROS1s2s3={captuROS1s2s3}
                updateS1S2S3Value={updateS1S2S3Value}
                handleChangeRecovery={handleChangeRecovery}
                recoveryPerCircuit={recoveryPerCircuit}
                conc_recirc_flow={conc_recirc_flow}
                handlerecoveryPerCircuit={handlerecoveryPerCircuit}
                translateObject={translateObject}
                captu_ro={captu_ro}
              />
            </Grid>
            <Grid item xs={12} style={{ 'marginTop': 2, marginRight: 10 }}>
              <Grid container className='no_drag'>
                <Grid item xs={3.5}>
                  <Radio
                    checked={clroRadioSelectedValue === '0'}
                    onChange={handleChangeRadio}
                    value="0"
                    name="radio-buttons"
                    sx={{
                      color: '#0000001F',
                      '&.Mui-checked': {
                        color: '#00AEC7',
                      },
                    }}
                  />
                  <label className='radio-text no_drag'>{translateObject('Use Element Age and Annual % Change')}</label>
                </Grid>
                <Grid item xs={3.5}>
                  <Radio
                    checked={clroRadioSelectedValue === '1'}
                    onChange={handleChangeRadio}
                    value="1"
                    name="radio-buttons"
                    sx={{
                      color: '#0000001F',
                      '&.Mui-checked': {
                        color: '#00AEC7',
                      },
                    }}
                  />
                  <label className='radio-text no_drag'>{translateObject('Input A Value Factor & B Value Factor')}</label>
                </Grid>
                {/* by sudarsana added for PrssureDrop field in CLRO Form */}
                {!captu_ro && (
                  <Grid item xs={5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <div className='field-text no_drag S_Bold' style={{ margin: '0 5px 0 0' }}>
                      {translateObject('Pressure drop during brine purge')}
                    </div>
                    <Grid item xs={12} style={{ display: 'contents' }}>
                      <input
                        style={{ textAlign: 'center' }}
                        // hiddenLabel
                        id="filled-hidden-label-small"
                        variant="outlined"
                        onMouseDown={(e) => getCurrentValue(e)}
                        onChange={(e) => { setpressureDrop(e.target.value); }}
                        onBlur={handlePressureDrop}
                        onFocus={e => e.target.select()}
                        className="Form_Input_design combined-input-field no_drag"
                        type="number"
                        name="dp_brinepurge"
                        value={pressureDrop}
                      />
                    </Grid>
                    <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ margin: '0 0 0 5px' }}>
                      {unit_set_dict.pressure}
                    </div>
                  </Grid>
                )}
                {captu_ro && (
                  <>
                    <Grid item xs={5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                      <div className='field-text no_drag S_Bold' style={{ margin: '0 5px 0 0' }}>
                        {translateObject('Recovery during brine purge')}
                      </div>
                      <Grid item xs={12} style={{ display: 'contents' }}>
                        <input
                          style={{ textAlign: 'center', padding: '0 5px' }}
                          // hiddenLabel
                          id="filled-hidden-label-small"
                          variant="outlined"
                          onMouseDown={(e) => getCurrentValue(e)}
                          onChange={(e) => { setRecoverybrine(e.target.value); }}
                          onBlur={handleRecoverybrine}
                          onFocus={e => e.target.select()}
                          className="Form_Input_design combined-input-field no_drag"
                          type="number"
                          name="dp_brinepurge"
                          value={recoverybrine}
                        />
                      </Grid>
                      <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ margin: '0 0 0 5px' }}>%</div>
                    </Grid>
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                      <div className='field-text no_drag S_Bold' style={{ margin: '0 5px 0 0' }}>
                        {translateObject('Feed Flow (per PV) during brine purge')}
                      </div>
                      <Grid item xs={12} style={{ display: 'contents' }}>
                        <input
                          style={{ textAlign: 'center', padding: '0 5px' }}
                          // hiddenLabel
                          id="filled-hidden-label-small"
                          variant="outlined"
                          onMouseDown={(e) => getCurrentValue(e)}
                          onChange={(e) => { setFlowDropPurge(e.target.value); }}
                          onBlur={handlePressureDrop}
                          onFocus={e => e.target.select()}
                          className="Form_Input_design combined-input-field no_drag"
                          type="number"
                          name="dp_brinepurge"
                          value={flowDropPurge}
                        />
                      </Grid>
                      <div
                        className='Form_Input_design_Units field-unit-text fright no_drag'
                        style={{ margin: '0 0 0 5px' }}>
                        {unit_set_dict.flow}
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} className="clro-table-grid no_drag">
              <div className="ro-table-component sansW4SeLig">
                <CLRoTable
                  checkPressureUnit={checkPressureUnit}
                  dbTransactionDetails={dbTransactionDetails}
                  elements={elements}
                  rowData={rowData}
                  handleAfterBlur={handleAfterBlur}
                  onValueChange={onValueChange}
                  handleClick={handleClick}
                  updateElementParameters={updateElementParameters}
                  gridRef={gridRef}
                  option={option}
                  colDefArr={colDefArr}
                  roDetails={roDetails}
                  enableRecyclePermeate={enableRecyclePermeate}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Box>
  );
};

export default CLRoFeedAnalysis;
